import { NotFound } from '@systemeio/util'
import { COURSES_API } from 'modules/courses/courses/api/courses-api'
import { CourseEditApiInterface, CourseId } from 'modules/courses/courses/types/course-interface'
import { useControlledSwr } from 'shared/hooks/use-controlled-swr'
import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import useUser from 'shared/hooks/use-user'
import { coursesDependencies } from '../../constants/courses-dependencies'

export function useCourse(id?: CourseId) {
  const { user } = useUser()
  const { fetcher } = useFetch<RequestMethodsEnum.get, CourseEditApiInterface>({
    method: RequestMethodsEnum.get,
    onErrorBeforeErrorHandlers: error => {
      if (error instanceof NotFound) {
        return undefined
      }
      throw error
    },
  })

  const {
    data: courseData,
    mutate,
    isLoading,
  } = useControlledSwr(
    () => user && id && [`${COURSES_API}/${id}`, ...coursesDependencies],
    fetcher,
  )

  return { courseData, mutate, isLoading }
}
